<template>
    <div :class="['bg-no-repeat md:py-16 py-12', classes]">
        <div class="px-4 sm:px-6 md:px-24 xl:container mx-auto" :class="rightBleed ? 'md:pr-0' : ''">
            <slot></slot>
        </div>
    </div>

</template>
<script>

export default {
    name: "BlockLayoutWrapper",
    props: {
        classes: {
            type: String,
            required: false
        },
        rightBleed: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
